import { ToasterMessageInterface } from './toaster-message/toaster-message.interface';
import { ToasterMessageComponent } from './toaster-message/toaster-message.component';

export type ToastOptions = Partial<
  Pick<ToasterMessageInterface, 'type' | 'icon' | 'dismissible' | 'duration'>
> & {
  headerOffset?: boolean;
  title: string;
  body?: string;
};

export class ToasterService {
  static Toast(settings: ToastOptions): ToasterMessageInterface {
    const toastMessage = ToasterService.CreateToastMessage(settings);

    if (settings.headerOffset) {
      ToasterMessageComponent.toastStack.setAttribute('headerOffset', '');
    } else {
      ToasterMessageComponent.toastStack.removeAttribute('headerOffset');
    }

    toastMessage.toast();

    return toastMessage;
  }

  static CreateToastMessage(
    settings: ToastOptions,
  ): HTMLElement & ToasterMessageInterface {
    const toastMessage = document.createElement('a-toaster-message');
    toastMessage.setAttribute('data-test', 'toast');

    Object.assign(toastMessage, settings);
    toastMessage.duration = settings.duration ?? 8000;
    toastMessage.dismissible = true;

    toastMessage.innerHTML = `
            <span slot="header">${settings.title}</span>
            ${settings.body ? `<span slot="body">${settings.body}</span>` : ''}
        `;

    return toastMessage;
  }

  static SetTarget(target: HTMLElement | null) {
    if (target === null) {
      if (ToasterMessageComponent.toastStack.parentElement !== document.body) {
        document.body.append(ToasterMessageComponent.toastStack);
      }
    } else {
      target.append(ToasterMessageComponent.toastStack);
    }
  }
}
